<template lang="pug">
  div#custom-content(v-if="contentVisible")
    // Correct Answer, Score
    el-row(:gutter="20" style="margin: 2%;")
      el-col(:span="24" style="display: flex; flex-direction: row; justify-content: flex-start; flex-wrap: wrap; align-items: baseline;") 
        div(style="flex-grow: 1;")
          math-quill-view#subtext(
            v-if="questionData.allow_math_equivs"
              :value="questionData.lefthand"
              style="padding-right: 10px;"
            )
          div#subtext(
            v-else
            class="mq-math-mode"
          ) {{ questionData.lefthand }}
          custom-point-badge(:value="score")
            math-quill-view#answer-box(
              v-if="questionData.allow_math_equivs"
              :value="questionData.correct_answer"
            )
            div#answer-box(
              v-else
            ) {{ questionData.correct_answer }}
          math-quill-view#subtext(
            v-if="questionData.allow_math_equivs"
            :value="questionData.righthand"
            style="padding-left: 10px;"
          )
          div#subtext(
            v-else
            class="mq-math-mode"
          ) {{ questionData.righthand }}

        // Custom Symbols
        div(v-if="questionSymbols.length >= 1 && questionData.allow_math_equivs"
          class="preview-customsymbols" style="flex-grow: 1;")
            label#sublabel Custom Symbols:
            span(v-for="sym, symIndex in questionSymbols")
              math-quill-view(
                :value="sym"
                style="font-size: 16px; margin-left: 5px;")
              span(v-if="symIndex < questionSymbols.length-1") ,
</template>

<script>
import MathQuillView from "@/components/utils/MathQuillView";
import CustomPointBadge from "@/components/demo/preview/CustomPointBadge";

export default {
  name: "AnswerInputPreview",

  components: {
    MathQuillView,
    CustomPointBadge
  },

  props: {
    questionData: {
      type: Object,
      required: true
    },

    contentVisible: {
      type: Boolean,
      required: true
    },

    score: {
      type: Number,
      default: 1
    }
  },

  computed: {
    questionSymbols() {
      let symbolsList = this.questionData.custom_symbols
        .toString()
        .replace(/['"]+/g, "");
      if (symbolsList != "") {
        return symbolsList.split(",");
      }
      return [];
    }
  }
};
</script>

<style module>
#sublabel {
  font-size: 12px;
  font-style: italic;
}

#subtext {
  font-size: 16px;
  margin-left: 5px;
}
</style>
